<form
  class="d-flex flex-column"
  [formGroup]="form"
  [ngClass]="{ 'was-validated': isFormSubmitted }"
>
  <p class="pre-line">{{ 'administration.invitation' | translate }}</p>

  <div class="d-flex gap-5 my-4">
    <div class="w-30 pt-2">
      <label class="required">{{ 'title' | translate }}</label>
    </div>
    <div class="w-50">
      <base-dropdown
        [items]="genderOptions"
        [translateItems]="true"
        formControlName="gender"
        [requiredLabel]="true"
        [searchable]="false"
        bindOptionLabel="label"
        baseFieldValidationArgs="title"
        placeholder="pleaseSelect"
      ></base-dropdown>
    </div>
  </div>

  <div class="d-flex gap-5 my-4">
    <div class="w-30 pt-2">
      <label class="required">{{ 'firstName' | translate }}</label>
    </div>
    <div class="w-70 ms-2">
      <base-input
        label=""
        formControlName="firstName"
        [isRequired]="true"
        [isInvalid]="!!form.controls.firstName.errors"
        errorMessage="validation.firstName"
      ></base-input>
    </div>
  </div>

  <div class="d-flex gap-5 my-4">
    <div class="w-30 pt-2">
      <label class="required">{{ 'lastName' | translate }}</label>
    </div>
    <div class="w-70 ms-2">
      <base-input
        label=""
        formControlName="lastName"
        [isRequired]="true"
        [isInvalid]="!!form.controls.lastName.errors"
        errorMessage="validation.lastName"
      ></base-input>
    </div>
  </div>

  <div class="d-flex gap-5 my-4">
    <div class="w-30 pt-2">
      <label class="required">{{ 'email' | translate }}</label>
    </div>
    <div class="w-70 ms-2">
      <base-input
        label=""
        formControlName="email"
        placeholder="sampleEmail"
        [isRequired]="true"
        [isEmailField]="true"
        [isInvalid]="!!form.controls.email.errors"
        errorMessage="validation.email"
      ></base-input>
    </div>
  </div>

  <div
    *ngIf="!isPSP"
    class="d-flex gap-5 my-4"
  >
    <div class="w-30 pt-2">
      <label [ngClass]="{ required: isAdmin }">{{ 'placeholders.role' | translate }}</label>
    </div>
    <div class="d-flex flex-column w-70 gap-2">
      <span
        *ngIf="!isAdmin"
        class="pt-2"
      >
        {{ 'user.singular' | translate }}
      </span>
      <ng-container *ngIf="isAdmin">
        <base-radiobutton
          name="role"
          class="rb"
          formControlName="role"
          label="placeholders.administrator"
          [value]="baseRoles.CUSTOMER_ADMIN"
        ></base-radiobutton>

        <base-radiobutton
          name="role"
          class="rb"
          formControlName="role"
          label="workCouncil.label"
          [value]="baseRoles.CUSTOMER_WORK_COUNCIL"
        ></base-radiobutton>

        <base-radiobutton
          name="role"
          class="rb"
          formControlName="role"
          label="user.singular"
          [value]="baseRoles.CUSTOMER_USER"
        ></base-radiobutton>
        <ng-container *ngIf="hasRoleControlGuard(form)">
          <div
            class="invalid-feedback"
            *ngIf="form.controls.role.errors as errors"
          >
            {{ errors | baseFieldValidation | translate }}
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div
    *ngIf="isPSP || hasGroupControl"
    class="d-flex gap-5 my-4"
  >
    <div class="w-30 pt-2">
      <label class="required">{{ 'permission.group' | translate }}</label>
    </div>
    <div class="w-50">
      <base-dropdown
        [items]="groups"
        formControlName="group"
        [requiredLabel]="true"
        [searchable]="false"
        [isInvalid]="!!form.controls.group?.errors"
        baseFieldValidationArgs="permissionGroup"
        placeholder="pleaseSelect"
      ></base-dropdown>
    </div>
  </div>

  <div
    *ngIf="!isPSP && hasCustomerLocationControl"
    class="d-flex gap-5 my-4"
  >
    <div class="w-30 pt-2">
      <label class="required">{{ 'location.singular' | translate }}</label>
    </div>
    <div class="w-50">
      <base-dropdown
        [items]="locations"
        [requiredLabel]="true"
        bindOptionLabel="name"
        baseFieldValidationArgs="selectLocation"
        [multiple]="true"
        [isInvalid]="hasCustomerLocationsControlGuard(form) && !!form.controls.customerLocations?.errors"
        formControlName="customerLocations"
        placeholder="pleaseSelect"
      ></base-dropdown>
    </div>
  </div>

  <div
    class="d-flex gap-5 my-4"
    *ngIf="isPSP"
  >
    <div class="w-30 pt-2">
      <label class="required">{{ 'branch.plural' | translate }}</label>
    </div>
    <div class="w-50">
      <base-dropdown
        [searchable]="false"
        [items]="pspBranches"
        [requiredLabel]="true"
        bindOptionLabel="primaryData.name"
        baseFieldValidationArgs="branchRequired"
        [multiple]="true"
        formControlName="pspBranches"
        placeholder="pleaseSelect"
        outputModel="id"
      ></base-dropdown>
    </div>
  </div>

  <div
    class="d-flex gap-5 my-4"
    *ngIf="!isPSP && hasCustomerDepartmentsControl"
  >
    <div class="w-30 pt-2">
      <label class="required">{{ 'department.plural' | translate }}</label>
    </div>
    <div class="w-50">
      <base-dropdown
        [items]="customerDepartments"
        [requiredLabel]="true"
        [multiple]="true"
        [customLayout]="true"
        formControlName="customerDepartments"
        bindOptionLabel="name"
        bindOptionSubLabel="locationName"
        baseFieldValidationArgs="selectDepartment"
        searchProperty="name,locationName"
        placeholder="pleaseSelect"
      ></base-dropdown>
    </div>
  </div>

  <div class="p-0 mb-5 mt-3 d-flex justify-content-between">
    <base-button
      [size]="buttonSizes.md"
      color="secondary"
      label="action.cancel"
      (btnClick)="cancelSendingInvitation()"
    ></base-button>
    <base-button
      [size]="buttonSizes.md"
      color="primary"
      label="action.sendInvitation"
      (btnClick)="confirmSendingInvitation()"
    ></base-button>
  </div>
</form>
